import {Component, forwardRef} from "@angular/core";
import {FUIAbstractPill} from "../../framework/abstract-pill";
import {NG_VALUE_ACCESSOR} from "@angular/forms";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUICheckboxPillComponent),
            multi: true
        }
    ],
    selector: "fui-checkbox-pill",
    templateUrl: "./checkbox-pill.component.html",
    standalone: false
})
export class FUICheckboxPillComponent extends FUIAbstractPill {
}
